const FALLBACK_API_ORIGIN = 'https://encreage-api.onrender.com';

function trimTrailingSlash(value) {
  return value.replace(/\/+$/, '');
}

function normalizePath(path = '') {
  if (!path) {
    return '';
  }

  return path.startsWith('/') ? path : `/${path}`;
}

function getConfiguredBaseUrl() {
  const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();

  if (configuredBaseUrl) {
    return trimTrailingSlash(configuredBaseUrl);
  }

  if (import.meta.env.DEV) {
    return '/api';
  }

  return `${FALLBACK_API_ORIGIN}/api`;
}

function ensureApiSuffix(baseUrl) {
  return baseUrl.endsWith('/api') ? baseUrl : `${baseUrl}/api`;
}

export function buildApiUrl(path = '') {
  const baseUrl = getConfiguredBaseUrl();
  const normalizedPath = normalizePath(path);

  if (baseUrl === '/api') {
    return `${baseUrl}${normalizedPath}`;
  }

  return `${ensureApiSuffix(baseUrl)}${normalizedPath}`;
}

export function buildRootUrl(path = '') {
  const baseUrl = getConfiguredBaseUrl();
  const normalizedPath = normalizePath(path);

  if (baseUrl === '/api') {
    return `/api${normalizedPath}`;
  }

  const rootBaseUrl = baseUrl.endsWith('/api') ? baseUrl.slice(0, -4) : baseUrl;

  return `${rootBaseUrl}${normalizedPath}`;
}
